module.exports = __webpack_public_path__ + "img/seguridad-mobile.97deee57.webp";